import React from 'react'
import * as S from './styles'
import { Currency, FormattedNumber } from '../../atoms/numberFormatCustom'

export const ResultTable = ({
	data,
	input,
}) => {
	const {
		simplifiedDeclaration,
		withUserSupplementaryPension,
		withSupplementaryPensionMaximum,
	} = data

	return (<S.Table style={{ widTableHeader: '100%' }}>
		<thead>
		<S.TableRow>
			<S.TableHeader left>Comparação do IRPF</S.TableHeader>
			<S.TableHeader>Simplificada</S.TableHeader>
			<S.TableHeader>Completa</S.TableHeader>
			<S.TableHeader>Sugestão</S.TableHeader>
		</S.TableRow>
		</thead>
		<tbody>
		<S.TableRow>
			<S.TableCell left>Renda bruta</S.TableCell>
			<S.TableCell>{`${Currency(
				simplifiedDeclaration.taxableGrossIncome)}`}</S.TableCell>
			<S.TableCell>{`${Currency(
				withUserSupplementaryPension.taxableGrossIncome)}`}</S.TableCell>
			<S.TableCell>{`${Currency(
				withSupplementaryPensionMaximum.taxableGrossIncome)}`}</S.TableCell>
		</S.TableRow>
		{/*<S.TableRow>*/}
		{/*  <S.TableCell left>Imposto pago na fonte</S.TableCell>*/}
		{/*  <S.TableCell>{`${StringFormattedNumber(simplifiedDeclaration.taxableGrossIncome)}`}</S.TableCell>*/}
		{/*  <S.TableCell>{`${StringFormattedNumber(withUserSupplementaryPension.taxableGrossIncome)}`}</S.TableCell>*/}
		{/*</S.TableRow>*/}
		<S.TableRow>
			<S.TableCell left>Desconto Simplificado</S.TableCell>
			<S.TableCell>{`${Currency(
				simplifiedDeclaration.otherDeduction)}`}</S.TableCell>
			<S.TableCell>0</S.TableCell>
			<S.TableCell>0</S.TableCell>
		</S.TableRow>
		<S.TableRow>
			<S.TableCell left>PGBL</S.TableCell>
			<S.TableCell>{`0`}</S.TableCell>
			<S.TableCell>{`${Currency(
				withUserSupplementaryPension.supplementaryPensionContribution)}`}</S.TableCell>
			<S.PurpleTableCell>{`${Currency(
				withSupplementaryPensionMaximum.supplementaryPensionContribution)}`}</S.PurpleTableCell>
		</S.TableRow>
		<S.TableRow>
			<S.TableCell left>INSS</S.TableCell>
			<S.TableCell>0</S.TableCell>
			<S.TableCell>{input.paysINSS === 'Sim' ? `${Currency(
				withUserSupplementaryPension.INSS)}` : `0`}</S.TableCell>
			<S.TableCell>{input.paysINSS === 'Sim' ? `${Currency(
				withSupplementaryPensionMaximum.INSS)}` : `0`}</S.TableCell>
		</S.TableRow>
		<S.TableRow>
			<S.TableCell left>Dependentes</S.TableCell>
			<S.TableCell>0</S.TableCell>
			<S.TableCell>{`${Currency(
				withUserSupplementaryPension.dependentsDeduction)}`}</S.TableCell>
			<S.TableCell>{`${Currency(
				withSupplementaryPensionMaximum.dependentsDeduction)}`}</S.TableCell>
		</S.TableRow>
		<S.TableRow>
			<S.TableCell left>Educação própria</S.TableCell>
			<S.TableCell>0</S.TableCell>
			<S.TableCell>{`${Currency(
				withUserSupplementaryPension.educationDeduction)}`}</S.TableCell>
			<S.TableCell>{`${Currency(
				withSupplementaryPensionMaximum.educationDeduction)}`}</S.TableCell>
		</S.TableRow>
		<S.TableRow>
			<S.TableCell left>Saúde</S.TableCell>
			<S.TableCell>0</S.TableCell>
			<S.TableCell>{`${Currency(
				withUserSupplementaryPension.medicalExpense)}`}</S.TableCell>
			<S.TableCell>{`${Currency(
				withSupplementaryPensionMaximum.medicalExpense)}`}</S.TableCell>
		</S.TableRow>
		<S.TableRow>
			<S.TableCell left>Pensão alimentícia</S.TableCell>
			<S.TableCell>0</S.TableCell>
			<S.TableCell>{`${Currency(
				withUserSupplementaryPension.alimonyYearlyExpenses)}`}</S.TableCell>
			<S.TableCell>{`${Currency(
				withSupplementaryPensionMaximum.alimonyYearlyExpenses)}`}</S.TableCell>
		</S.TableRow>
		<S.TableRow>
			<S.TableCell left><strong>Base tributável</strong></S.TableCell>
			<S.TableCell><strong>{`${Currency(
				simplifiedDeclaration.incomeTaxBaseValue)}`}</strong></S.TableCell>
			<S.TableCell><strong>{`${Currency(
				withUserSupplementaryPension.incomeTaxBaseValue)}`}</strong></S.TableCell>
			<S.TableCell><strong>{`${Currency(
				withSupplementaryPensionMaximum.incomeTaxBaseValue)}`}</strong></S.TableCell>
		</S.TableRow>
		<S.TableRow>
			<S.TableCell left>Dedução (%)</S.TableCell>
			<S.TableCell>{`${FormattedNumber(
				simplifiedDeclaration.percentageDeduction)}%`}</S.TableCell>
			<S.TableCell>{`${FormattedNumber(
				withUserSupplementaryPension.percentageDeduction)}%`}</S.TableCell>
			<S.TableCell>{`${FormattedNumber(
				withSupplementaryPensionMaximum.percentageDeduction)}%`}</S.TableCell>
		</S.TableRow>

		<S.TableRow  >
			<S.RedTableHeader  left>Imposto Devido</S.RedTableHeader>
			<S.RedTableHeader>{`${Currency(simplifiedDeclaration.taxValue)}`}</S.RedTableHeader>
			<S.RedTableHeader>{`${Currency(
				withUserSupplementaryPension.taxValue)}`}</S.RedTableHeader>
			<S.RedTableHeader>{`${Currency(
				withSupplementaryPensionMaximum.taxValue)}`}</S.RedTableHeader>
		</S.TableRow>
		</tbody>
	</S.Table>)
}